module.exports = __webpack_public_path__ + "img/home-bg4-4.3ddaab04.png";